export default "__VITE_ASSET__CqgbIpSw__"